<undo-redo></undo-redo>
<div class="bar"></div>
<div class="select-options">
    <div class="bar-btn" title="Calculatie regel toevoegen [F9] (+Shift = boven selectie)" (click)="_insertLine($event)"
        [class.inactive]="isTableLocked || (calculationLineSelected | not) || (singleSelected | not)">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
            height="20" viewBox="0 0 20 20">
            <path
                d="M7.5 10h-6c-0.827 0-1.5-0.673-1.5-1.5v-6c0-0.827 0.673-1.5 1.5-1.5h6c0.827 0 1.5 0.673 1.5 1.5v6c0 0.827-0.673 1.5-1.5 1.5zM1.5 2c-0.276 0-0.5 0.224-0.5 0.5v6c0 0.276 0.224 0.5 0.5 0.5h6c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5h-6z"
                fill="#000000"></path>
            <path
                d="M7.5 20h-6c-0.827 0-1.5-0.673-1.5-1.5v-6c0-0.827 0.673-1.5 1.5-1.5h6c0.827 0 1.5 0.673 1.5 1.5v6c0 0.827-0.673 1.5-1.5 1.5zM1.5 12c-0.276 0-0.5 0.224-0.5 0.5v6c0 0.276 0.224 0.5 0.5 0.5h6c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5h-6z"
                fill="#000000"></path>
            <path
                d="M6.5 6h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                fill="#000000"></path>
            <path
                d="M6.5 15h-1.5v-1.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v1.5h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"
                fill="#000000"></path>
            <path
                d="M17.5 20h-6c-0.827 0-1.5-0.673-1.5-1.5v-16c0-0.827 0.673-1.5 1.5-1.5h6c0.827 0 1.5 0.673 1.5 1.5v16c0 0.827-0.673 1.5-1.5 1.5zM11.5 2c-0.276 0-0.5 0.224-0.5 0.5v16c0 0.276 0.224 0.5 0.5 0.5h6c0.276 0 0.5-0.224 0.5-0.5v-16c0-0.276-0.224-0.5-0.5-0.5h-6z"
                fill="#000000"></path>
            <path
                d="M16.5 10h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                fill="#000000"></path>
            <path
                d="M16.5 12h-4c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                fill="#000000"></path>
        </svg>
    </div>

    <div class="bar-btn" title="Tekst regel toevoegen [F8] (+Shift = boven selectie)"
        (click)="_insertLine($event, true)"
        [class.inactive]="isTableLocked || (singleSelected | not) || (calculationLineSelected | not)">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
            height="20" viewBox="0 0 20 20">
            <path
                d="M16.5 19h-14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h14c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                fill="#000000"></path>
            <path
                d="M15.96 15.303l-2.57-5.996c-0.001-0.001-0.001-0.003-0.002-0.004l-3.428-8c-0.079-0.184-0.26-0.303-0.46-0.303s-0.381 0.119-0.46 0.303l-3.428 8c-0.001 0.002-0.001 0.003-0.002 0.005l-2.57 5.996c-0.109 0.254 0.009 0.548 0.263 0.657s0.548-0.009 0.657-0.263l2.442-5.697h6.198l2.442 5.697c0.081 0.19 0.266 0.303 0.46 0.303 0.066 0 0.133-0.013 0.197-0.041 0.254-0.109 0.371-0.403 0.263-0.657zM6.83 9l2.67-6.231 2.67 6.231h-5.341z"
                fill="#000000"></path>
        </svg>
    </div>

    <div class="bar-btn" title="Wijzig regeltype (alt+5)" (click)="_changeLineType()"
        [class.inactive]="isTableLocked || (singleSelected | not)">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
            height="20" viewBox="0 0 20 20">
            <path
                d="M18.354 7.146l-3-3c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2.146 2.146h-14.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h14.293l-2.146 2.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l3-3c0.195-0.195 0.195-0.512 0-0.707z"
                fill="#000000"></path>
            <path
                d="M17.5 13h-14.293l2.146-2.146c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-3 3c-0.195 0.195-0.195 0.512 0 0.707l3 3c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-2.146-2.146h14.293c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"
                fill="#000000"></path>
        </svg>
    </div>

    <div class="bar-btn" title="Selectie verwijderen [F10]" (click)="_deleteSelection()"
        [class.inactive]="isTableLocked || singleSelected | not">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
            height="20" viewBox="0 0 20 20">
            <path
                d="M15.5 2h-3.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-2c-0.827 0-1.5 0.673-1.5 1.5v0.5h-3.5c-0.827 0-1.5 0.673-1.5 1.5v1c0 0.652 0.418 1.208 1 1.414v12.586c0 0.827 0.673 1.5 1.5 1.5h10c0.827 0 1.5-0.673 1.5-1.5v-12.586c0.582-0.206 1-0.762 1-1.414v-1c0-0.827-0.673-1.5-1.5-1.5zM8 1.5c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v0.5h-3v-0.5zM14.5 19h-10c-0.276 0-0.5-0.224-0.5-0.5v-12.5h11v12.5c0 0.276-0.224 0.5-0.5 0.5zM16 4.5c0 0.276-0.224 0.5-0.5 0.5h-12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5h12c0.276 0 0.5 0.224 0.5 0.5v1z"
                fill="#000000"></path>
            <path
                d="M12.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"
                fill="#000000"></path>
            <path
                d="M9.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"
                fill="#000000"></path>
            <path
                d="M6.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z"
                fill="#000000"></path>
        </svg>
    </div>

    <div class="bar-btn" title="Subtotaal na geselecteerde regel" (click)="_toggleSectionEnd()"
        [class.inactive]="isTableLocked || !singleSelected" [class.highlighted]="singleSelected && isSectionEnd">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
            height="20" viewBox="0 0 20 20">
            <path
                d="M14.5 18h-10c-0.187 0-0.359-0.105-0.445-0.271s-0.071-0.367 0.038-0.519l4.792-6.709-4.792-6.709c-0.109-0.152-0.123-0.353-0.038-0.519s0.257-0.271 0.445-0.271h10c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-9.028l4.435 6.209c0.124 0.174 0.124 0.407 0 0.581l-4.435 6.209h9.028c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
                fill="#000000"></path>
        </svg>
    </div>

</div>

<div class="bar"></div>

<div class="bar-btn" title="Regels toevoegen" (click)="_showAddItemModal()" [class.inactive]="isTableLocked">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
        height="20" viewBox="0 0 20 20">
        <path
            d="M17.854 5.646l-4.5-4.5c-0.094-0.094-0.221-0.146-0.354-0.146h-9.5c-0.827 0-1.5 0.673-1.5 1.5v16c0 0.827 0.673 1.5 1.5 1.5h13c0.827 0 1.5-0.673 1.5-1.5v-12.5c0-0.133-0.053-0.26-0.146-0.354zM16.793 6h-3.293c-0.276 0-0.5-0.224-0.5-0.5v-3.293l3.793 3.793zM16.5 19h-13c-0.276 0-0.5-0.224-0.5-0.5v-16c0-0.276 0.224-0.5 0.5-0.5h8.5v3.5c0 0.827 0.673 1.5 1.5 1.5h3.5v11.5c0 0.276-0.224 0.5-0.5 0.5z"
            fill="#000000"></path>
        <path
            d="M14.5 10h-9c-0.276 0-0.5 0.224-0.5 0.5v6c0 0.276 0.224 0.5 0.5 0.5h9c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM14 13h-2v-2h2v2zM9 13v-2h2v2h-2zM11 14v2h-2v-2h2zM8 11v2h-2v-2h2zM6 14h2v2h-2v-2zM12 16v-2h2v2h-2z"
            fill="#000000"></path>
    </svg>
</div>

<div class="bar-btn" title="Bibliotheek (f6)" (click)="_showAddLibraryItemModal()" [class.inactive]="isTableLocked">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
        height="20" viewBox="0 0 20 20">
        <path
            d="M10.5 0h-2c-0.827 0-1.5 0.673-1.5 1.5v0.586c-0.157-0.056-0.325-0.086-0.5-0.086h-5c-0.827 0-1.5 0.673-1.5 1.5v15c0 0.827 0.673 1.5 1.5 1.5h5c0.384 0 0.734-0.145 1-0.383 0.266 0.238 0.616 0.383 1 0.383h2c0.827 0 1.5-0.673 1.5-1.5v-17c0-0.827-0.673-1.5-1.5-1.5zM6.5 19h-5c-0.276 0-0.5-0.224-0.5-0.5v-15c0-0.276 0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5v15c0 0.276-0.224 0.5-0.5 0.5zM11 18.5c0 0.276-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5-0.224-0.5-0.5v-17c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v17z"
            fill="#000000"></path>
        <path
            d="M5.5 6h-2.859c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2.859c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
            fill="#000000"></path>
        <path
            d="M18.61 19.623l-2.978 0.366c-0.821 0.101-1.571-0.485-1.672-1.306l-1.95-15.881c-0.101-0.821 0.485-1.571 1.306-1.672l2.978-0.366c0.821-0.101 1.571 0.485 1.672 1.306l1.95 15.881c0.101 0.821-0.485 1.571-1.306 1.672zM13.439 2.123c-0.274 0.034-0.469 0.284-0.435 0.557l1.95 15.881c0.034 0.274 0.284 0.469 0.557 0.435l2.978-0.366c0.274-0.034 0.469-0.284 0.435-0.557l-1.95-15.881c-0.034-0.274-0.284-0.469-0.557-0.435l-2.978 0.366z"
            fill="#000000"></path>
        <path
            d="M15.79 4.857l-0.993 0.122c-0.274 0.034-0.524-0.161-0.557-0.435s0.161-0.524 0.435-0.557l0.993-0.122c0.274-0.034 0.524 0.161 0.557 0.435s-0.161 0.524-0.435 0.557z"
            fill="#000000"></path>
    </svg>
</div>

<div class="bar-btn" title="Kopiëren vanaf calculatie (f5)" (click)="_showCopyLinesModal()"
    [class.inactive]="isTableLocked">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
        height="20" viewBox="0 0 20 20">
        <path
            d="M16.5 4h-2.5v-2.5c0-0.827-0.673-1.5-1.5-1.5h-7.5c-0.133 0-0.26 0.053-0.354 0.146l-3.5 3.5c-0.094 0.094-0.146 0.221-0.146 0.354v10.5c0 0.827 0.673 1.5 1.5 1.5h2.5v2.5c0 0.827 0.673 1.5 1.5 1.5h10c0.827 0 1.5-0.673 1.5-1.5v-13c0-0.827-0.673-1.5-1.5-1.5zM5 1.207v2.293c0 0.276-0.224 0.5-0.5 0.5h-2.293l2.793-2.793zM2.5 15c-0.276 0-0.5-0.224-0.5-0.5v-9.5h2.5c0.827 0 1.5-0.673 1.5-1.5v-2.5h6.5c0.276 0 0.5 0.224 0.5 0.5v2.5h-4c-0.133 0-0.26 0.053-0.354 0.146l-3.5 3.5c-0.094 0.094-0.146 0.221-0.146 0.354v7h-2.5zM9 5.207v2.293c0 0.276-0.224 0.5-0.5 0.5h-2.293l2.793-2.793zM17 18.5c0 0.276-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5-0.224-0.5-0.5v-9.5h2.5c0.827 0 1.5-0.673 1.5-1.5v-2.5h6.5c0.276 0 0.5 0.224 0.5 0.5v13z"
            fill="#000000"></path>
    </svg>
</div>

<div class="bar"></div>

<hourly-rate-dropdown title="Uurloon"></hourly-rate-dropdown>

<div class="bar"></div>

<mat-button-toggle-group [(ngModel)]="show" (ngModelChange)="changeVisibleParts($event)"
    aria-label="Show calculation parts" appearance="legacy">
    <!-- <mat-button-toggle value="calculation">calculatie</mat-button-toggle> -->
    <mat-button-toggle value="all">alles</mat-button-toggle>
    <mat-button-toggle value="tail">staart</mat-button-toggle>
</mat-button-toggle-group>

<div class="bar-btn" title="Staartregel toevoegen" (click)="_insertTailLine($event)" [class.inactive]="isTableLocked">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20"
        height="20" viewBox="0 0 20 20">
        <path
            d="M16.5 20h-14c-0.827 0-1.5-0.673-1.5-1.5v-17c0-0.827 0.673-1.5 1.5-1.5h14c0.827 0 1.5 0.673 1.5 1.5v17c0 0.827-0.673 1.5-1.5 1.5zM2.5 1c-0.276 0-0.5 0.224-0.5 0.5v17c0 0.276 0.224 0.5 0.5 0.5h14c0.276 0 0.5-0.224 0.5-0.5v-17c0-0.276-0.224-0.5-0.5-0.5h-14z"
            fill="#000000"></path>
        <path
            d="M15.5 7h-12c-0.276 0-0.5-0.224-0.5-0.5v-4c0-0.276 0.224-0.5 0.5-0.5h12c0.276 0 0.5 0.224 0.5 0.5v4c0 0.276-0.224 0.5-0.5 0.5zM4 6h11v-3h-11v3z"
            fill="#000000"></path>
        <path
            d="M15.5 8h-12c-0.276 0-0.5 0.224-0.5 0.5v9c0 0.276 0.224 0.5 0.5 0.5h12c0.276 0 0.5-0.224 0.5-0.5v-9c0-0.276-0.224-0.5-0.5-0.5zM15 11h-2v-2h2v2zM7 12h2v2h-2v-2zM6 14h-2v-2h2v2zM7 11v-2h2v2h-2zM9 15v2h-2v-2h2zM10 15h2v2h-2v-2zM12 14h-2v-2h2v2zM10 11v-2h2v2h-2zM6 9v2h-2v-2h2zM4 15h2v2h-2v-2zM13 17v-5h2v5h-2z"
            fill="#000000"></path>
    </svg>
</div>

